
/**
 * First we will load all of this project's JavaScript dependencies
 * Uncomment those as requried.
 */

require('./bootstrap');



// WEBPACK FOOTER //
// ./src/js/app.js